import React from 'react';

const Button = ({className,icon, disabled, onClick}) => {
    return (
        <button onClick={onClick} className={`btn ${className ? className:''}`} disabled={disabled}>
            {   icon &&
                <img className={'btn__icon'} src={icon} alt="icon"/>
            }
        </button>
    );
};


export default Button;